module.exports = __webpack_public_path__ + "static/media/img404.256a2552.png";